export default ({
  backgroundColor: '#777',
  headerBackgroundColor: '#333',
  headerColor: 'rgba(249, 252, 255, 0.8)',
  headerColorActive: '#fff',
  headerFocusColor: 'rgba(249, 252, 255, 0.15)',
  sidebarBackgroundColor: '#444',
  sidebarColor: 'rgba(249, 252, 255, 0.8)',
  sidebarColorActive: '#fff',
  sidebarDarkMode: true,
  sidebarHeaderBackgroundColor: '#333',
  sidebarHeaderColor: 'rgba(249, 252, 255, 0.8)',
  sidebarHeaderColorActive: '#fff',
  sidebarInnerBackgroundColor: 'rgba(0, 0, 0, 0.15)',
  sidebarInnerColor: 'rgba(249, 252, 255, 0.8)',
  sidebarInnerColorActive: '#fff'
});
